var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrum30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4926 3.72823C15.1072 3.72823 18.0375 3.1175 18.0375 2.36412C18.0375 1.61074 15.1072 1 11.4926 1C7.87794 1 4.94768 1.61074 4.94768 2.36412C4.94768 3.1175 7.87794 3.72823 11.4926 3.72823Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.771 21.8971C17.771 22.5066 14.9724 23 11.5222 23C8.07206 23 5.27345 22.5066 5.27345 21.8971"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9112 15.1201C18.9112 15.9037 15.6091 16.5567 11.5222 16.5567C7.43534 16.5567 4.13327 15.9037 4.13327 15.1201"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8223 9.08311C18.8223 9.86675 15.5498 10.5198 11.5074 10.5198C7.46495 10.5198 4.2073 9.88127 4.2073 9.08311"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6821 2.77045C18.5114 5.5277 19 8.89446 19 12.5224C19 16.1504 18.541 19.2995 17.7562 22.0132"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28825 22.0277C4.47384 19.314 4 16.0343 4 12.5079C4 8.98153 4.50345 5.51319 5.36229 2.75594"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrum30);
export default __webpack_public_path__ + "static/media/Drum30.6f559fca076ac98a79cee12000ca8f02.svg";
export { ForwardRef as ReactComponent };